export const T = {
  fr: {
    hero: {
      title: 'AX-IOM',
      tagline: 'Decide with method.',
      desc: "Des décisions d'investissement claires et traçables, issues d'algorithmes propriétaires. Actions & Crypto. Sans bruit. Sans promesse.",
      cta: "Rejoindre la liste d'attente",
      example: 'Voir un exemple'
    },
    problem: {
      label: 'Le problème',
      title: 'Le marché est saturé de bruit',
      text: 'Opinions contradictoires, signaux ambigus, promesses non tenues. Les investisseurs ont besoin de décisions, pas de bruit.'
    },
    solution: {
      label: 'La solution',
      title: 'Des décisions structurées',
      text: "AX-IOM fournit des recommandations multi-actifs avec niveaux d'entrée, invalidation, objectifs, horizon et risque explicites.",
      cards: [
        { title: 'Niveaux précis', desc: 'Entrée, objectif(s), invalidation clairement définis pour chaque recommandation.' },
        { title: 'Risque visible', desc: 'Score de confiance, horizon temporel et risque max toujours affichés.' },
        { title: 'Traçabilité totale', desc: 'Historique complet, chaque décision documentée et auditable.' }
      ]
    },
    why: {
      label: 'Pourquoi AX-IOM',
      items: ['Algorithmes propriétaires (actions + crypto)', 'Méthode > hype', 'Transparence intelligente', 'Posture institutionnelle']
    },
    how: {
      label: 'Comment ça marche',
      steps: [
        { title: 'Définissez', desc: 'Votre profil de risque' },
        { title: 'Recevez', desc: 'Des décisions claires' },
        { title: 'Exécutez', desc: 'Où vous voulez' },
        { title: 'Suivez', desc: 'La performance' }
      ]
    },
    pricing: {
      label: 'Tarifs',
      title: 'Choisissez votre couverture',
      annual: '–20% en annuel',
      plans: [
        { name: 'Core', price: '59', desc: 'Couverture essentielle', features: ['Actions OU Crypto', 'Recommandations actives', 'Historique 30 jours', 'Alertes email'], disabled: ['Statistiques avancées', 'Alertes prioritaires'] },
        { name: 'Pro', price: '129', desc: 'Couverture complète', featured: true, features: ['Actions ET Crypto', 'Recommandations actives', 'Historique complet', 'Alertes temps réel', 'Statistiques avancées', 'Export PDF'], disabled: ['Accès anticipé'] },
        { name: 'Elite', price: '399', desc: 'Places limitées', features: ['Tout Pro inclus', 'Accès anticipé (24h)', 'Commentaires privés', 'Support direct', 'Insights exclusifs'], disabled: [] }
      ]
    },
    disclaimer: {
      label: 'Avertissement important',
      text: "AX-IOM fournit des recommandations générales et ne constitue pas un conseil en investissement personnalisé. Aucune promesse de rendement. La décision finale appartient à l'utilisateur. Les performances passées ne préjugent pas des performances futures."
    },
    app: {
      active: 'Actives',
      recommendations: 'Recommandations',
      history: 'Historique',
      performance: 'Performance',
      alerts: 'Alertes',
      settings: 'Paramètres',
      all: 'Tout',
      stocks: 'Actions',
      crypto: 'Crypto',
      entry: 'Entrée',
      target: 'Objectif',
      stop: 'Invalidation',
      riskMax: 'Risque max',
      confidence: 'Score de confiance',
      horizon: 'Horizon',
      winRate: 'Win Rate',
      avgReturn: 'Rendement moyen',
      totalRecos: 'Recommandations totales',
      activeRecos: 'Recos actives'
    },
    onboarding: {
      title: 'Bienvenue sur AX-IOM',
      subtitle: 'Configurez votre profil en 3 étapes',
      step1: 'Profil de risque',
      step2: "Classes d'actifs",
      step3: 'Confirmation',
      conservative: 'Conservateur',
      conservativeDesc: 'Risque faible, rendements stables',
      balanced: 'Équilibré',
      balancedDesc: 'Risque/rendement modéré',
      aggressive: 'Agressif',
      aggressiveDesc: 'Risque élevé, potentiel élevé',
      continue: 'Continuer',
      complete: 'Commencer',
      accept: "J'accepte les conditions"
    }
  },
  en: {
    hero: {
      title: 'AX-IOM',
      tagline: 'Decide with method.',
      desc: 'Clear, traceable investment decisions from proprietary algorithms. Stocks & Crypto. No noise. No promises.',
      cta: 'Join the waitlist',
      example: 'See an example'
    },
    problem: {
      label: 'The problem',
      title: 'Markets are saturated with noise',
      text: 'Contradictory opinions, ambiguous signals, broken promises. Investors need decisions, not noise.'
    },
    solution: {
      label: 'The solution',
      title: 'Structured decisions',
      text: 'AX-IOM provides multi-asset recommendations with entry levels, invalidation, targets, horizon and explicit risk.',
      cards: [
        { title: 'Precise levels', desc: 'Entry, target(s), invalidation clearly defined for each recommendation.' },
        { title: 'Visible risk', desc: 'Confidence score, time horizon and max risk always displayed.' },
        { title: 'Full traceability', desc: 'Complete history, every decision documented and auditable.' }
      ]
    },
    pricing: {
      label: 'Pricing',
      title: 'Choose your coverage',
      annual: '–20% annually',
      plans: [
        { name: 'Core', price: '59', desc: 'Essential coverage', features: ['Stocks OR Crypto', 'Active recommendations', '30-day history', 'Email alerts'], disabled: ['Advanced statistics', 'Priority alerts'] },
        { name: 'Pro', price: '129', desc: 'Complete coverage', featured: true, features: ['Stocks AND Crypto', 'Active recommendations', 'Full history', 'Real-time alerts', 'Advanced statistics', 'PDF export'], disabled: ['Early access'] },
        { name: 'Elite', price: '399', desc: 'Limited seats', features: ['Everything in Pro', 'Early access (24h)', 'Private commentary', 'Direct support', 'Exclusive insights'], disabled: [] }
      ]
    },
    disclaimer: {
      label: 'Important notice',
      text: 'AX-IOM provides general recommendations and does not constitute personalized investment advice. No performance promises. Final decision belongs to the user. Past performance does not guarantee future results.'
    },
    app: {
      active: 'Active',
      recommendations: 'Recommendations',
      history: 'History',
      performance: 'Performance',
      alerts: 'Alerts',
      settings: 'Settings',
      all: 'All',
      stocks: 'Stocks',
      crypto: 'Crypto',
      entry: 'Entry',
      target: 'Target',
      stop: 'Invalidation',
      riskMax: 'Max risk',
      confidence: 'Confidence score',
      horizon: 'Horizon',
      winRate: 'Win Rate',
      avgReturn: 'Avg Return',
      totalRecos: 'Total recommendations',
      activeRecos: 'Active recos'
    },
    onboarding: {
      title: 'Welcome to AX-IOM',
      subtitle: 'Configure your profile in 3 steps',
      step1: 'Risk profile',
      step2: 'Asset classes',
      step3: 'Confirmation',
      conservative: 'Conservative',
      conservativeDesc: 'Low risk, stable returns',
      balanced: 'Balanced',
      balancedDesc: 'Moderate risk/reward',
      aggressive: 'Aggressive',
      aggressiveDesc: 'Higher risk, higher potential',
      continue: 'Continue',
      complete: 'Get Started',
      accept: 'I accept the terms'
    }
  }
};

export const useT = (lang) => T[lang] || T.fr;
